import { createContext } from "react";

export interface State {
    search: string;
    categories: number[];
}
type Action =
    | { type: "FILTER_BY_CATEGORIES"; payload: number[] }
    | { type: "SEARCH"; payload: string };

export interface ContextType {
    state: State;
    dispatch: React.Dispatch<Action>;
}

export const initialState: State = {
    search: "",
    categories: [],
};

export const ArticlesContext = createContext<ContextType | null>(null);

export const articlesReducer = (state: State, action: Action) => {
    switch (action.type) {
        case "FILTER_BY_CATEGORIES":
            return {
                ...state,
                categories: action.payload,
            };
        case "SEARCH":
            return {
                ...state,
                search: action.payload,
            };
        default:
            return state;
    }
};
